import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../environments/environment';

@Injectable()
export class ErrorService {

  // Observable string sources
  private errors = new BehaviorSubject<any>({ isErrorPresence: false });

  // Observable string streams
  resetErrorObservable = this.errors.asObservable();

  // Service message commands
  public addError(error: any) {
    this.errors.next(error);
  }

  public removeError() {
    const error = [];
    this.errors.next(error);
  }

  public addConnectedNotification() {
    if (environment.production === false) {
      this.addError([{ 'translationKey': 'wifiConnected', 'type': 'keyOnly' }]);
    }
  }
}
